import cn from 'classnames';
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';
import isNumber from 'lodash/isNumber';
import { DeviationResourceType } from '../../../types/deviation';
export var alignmentClassName = function (componentData, theme, styles, isMobile) {
    var _a = componentData.config || {}, alignment = _a.alignment, size = _a.size;
    if (!alignment || isMobile) {
        return '';
    }
    var align = alignment;
    if (size === 'original' && alignment !== 'center') {
        var width = (componentData.src || {}).width;
        if (isNumber(width) && width > 350) {
            align = 'center';
        }
    }
    return cn(styles["align".concat(upperFirst(align))], theme["align".concat(upperFirst(align))]);
};
export var sizeClassName = function (componentData, theme, styles, isMobile) {
    var _a;
    var size = (componentData.config || {}).size;
    var isTier = ((_a = componentData.data) === null || _a === void 0 ? void 0 : _a.typeId) === DeviationResourceType.TIER;
    var classNames = [theme['imagePlugin'], isTier && theme['imagePlugin_tier']];
    if (size) {
        classNames = classNames.concat(isMobile
            ? [styles.sizeFullWidth, theme.sizeFullWidth]
            : [
                styles["size".concat(upperFirst(camelCase(size)))],
                theme["size".concat(upperFirst(camelCase(size)))],
            ]);
    }
    return cn(classNames);
};
//# sourceMappingURL=classNameStrategies.js.map